module.exports = global["p2"] = require("-!./p2.js");


//////////////////
// WEBPACK FOOTER
// ./~/phaser-ce/build/custom/p2.js-exposed
// module id = 101
// module chunks = 1